import { RouteRecordRaw } from "vue-router";
import RegisterView from "@/views/site/RegisterView.vue";
import IndividualPurchaseView from "@/views/site/IndividualPurchaseView.vue";
import IndividualPurchaseSuccessView from "@/views/site/IndividualPurchaseSuccessView.vue";
import SchoolActivationView from "@/views/site/SchoolActivationView.vue";
import PayInvoiceView from "@/views/site/PayInoiceView.vue";

const storeRoutes: RouteRecordRaw[] = [
  {
    path: "/purchase/individual/:step?",
    name: "ExtendIndividual",
    component: IndividualPurchaseView,
  },
  {
    path: "/purchase/individual/success",
    name: "ExtendIndividualSuccess",
    component: IndividualPurchaseSuccessView,
  },
  {
    path: "/register/school/activation",
    name: "SchoolActivation",
    component: SchoolActivationView,
    props: { mode: "activation" },
  },
  {
    path: "/register/school/add-classes",
    name: "SchoolAddAclass",
    component: SchoolActivationView,
    props: { mode: "addclasses" },
  },
  {
    path: "/register/school/extend",
    name: "SchoolExtend",
    component: SchoolActivationView,
    props: { mode: "extend" },
  },
  {
    path: "/register/:type?/:step?",
    name: "Register",
    component: RegisterView,
  },
  {
    path: "/trial",
    name: "Trial",
    component: () => import("../views/TrialView.vue"),
  },
  {
    path: "/pay-invoice/:invoiceId",
    name: "PayInvoice",
    component: PayInvoiceView,
  },
];

export default storeRoutes;
